/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import {
  ActionRequiredItem,
  ActionRequiredType,
  UpcomingEventCard,
  UpcomingEventFilter,
  UpcomingEventsTag,
} from '../../models/event-card/event-card.model';
import { Page as Pagination } from '../../models/page';
import { ObservableResult } from '../../store';
import { SharedUpcomingDataService } from './upcoming-data.service';

@Injectable()
export class MockSharedUpcomingDataService implements SharedUpcomingDataService {
  getUpcomingEventsCards(
    page: number,
    size: number,
    frameworkId?: string,
    tagId?: string,
  ): ObservableResult<Pagination<UpcomingEventCard>> {
    return ObservableResult.ofSuccess();
  }

  getUpcomingEventsTags(page: number, size: number, term?: string): ObservableResult<Pagination<UpcomingEventsTag>> {
    return ObservableResult.ofSuccess();
  }

  hasUpcomingEvents(): ObservableResult<boolean> {
    return ObservableResult.ofSuccess(true);
  }

  getUpcomingEventsByFilter(page: number, size: number, filter: UpcomingEventFilter): ObservableResult<Pagination<UpcomingEventCard>> {
    return ObservableResult.ofSuccess();
  }

  getEventsEngagements(page: number, size: number, filter: UpcomingEventFilter): ObservableResult<Pagination<UpcomingEventCard>> {
    return ObservableResult.ofSuccess();
  }

  getActionRequiredItems(page: number, size: number, types?: ActionRequiredType[]): ObservableResult<Pagination<ActionRequiredItem>> {
    return ObservableResult.ofSuccess({ content: [], totalNumberOfElement: 0, pageSize: size, currentPageNumber: page });
  }
}
